import {Component, OnInit, ViewChild, Input, ElementRef} from '@angular/core';
import {CalendarViewerComponent, CalendarViewerDate} from "../calendar-viewer/calendar-viewer.component";
import {xCalendar} from "../utils/xCalendar";
import {CalendarService} from "../calendar.service";
import {CalEvent} from "../utils/model/CalEvent";

@Component({
  selector: 'calendar-widget',
  templateUrl: './calendar-widget.component.html',
  styleUrls: ['./calendar-widget.component.scss']
})
export class CalendarWidgetComponent implements OnInit {
  @ViewChild('calendarViewer') calendarViewer!: CalendarViewerComponent;
  @ViewChild('viewToggle') viewToggle!: ElementRef;
  @Input() locale: string = 'vi';
  @Input() dateFormat: string = 'dddd, D/M/YYYY';
  activeDateViewer?: CalendarViewerDate;
  activeDateTitle?: string;

  colors = [
    '#438EB9',
    '#3CA54A',
    '#FF9800',
    '#EF5B49',
    '#77901B',
    '#7D5392',
    '#808080'
  ];
  private _date?: Date;

  constructor(private calendarService: CalendarService) {
  }

  ngOnInit() {
    this.loadEvents();
  }

  changeMonth(date: Date) {
    this._date = date;
    this.calendarViewer.clearEvents();
    this.loadEvents();
  }

  activeDate(e: CalendarViewerDate) {
    this.activeDateViewer = e;
    this.activeDateTitle = xCalendar.formatDate(e.date, this.dateFormat);
  }

  loadEvents() {
    if (!this._date) {
      return;
    }

    this.calendarService.loadMonthEvents(this._date, (events: any) => {
      events.sort(function (a: any, b: any) {
        return a.day - b.day;
      });

      this._groupEventByDate(events).forEach((group) => {
        this.calendarViewer.setEvents(group.events, group.date);
      });

      // Focus today
      if (!this.activeDateViewer) {
        this.calendarViewer.focusDate(new Date());
      }
    });
  }

  onViewEvent(event: CalEvent, jsEvent: MouseEvent, targetEl: HTMLElement) {
    this.calendarService.viewEvent(event, jsEvent, targetEl, () => this.loadEvents());
  }

  private _groupEventByDate(events: any) {
    let groups: any[] = [];

    events.forEach((event: any) => {
      let group;
      let date = new Date(event.from);
      date.setHours(0, 0, 0, 0);

      for (let i = 0; i < groups.length; i++) {
        if (groups[i].date.getTime() === date.getTime()) {
          group = groups[i];
          break;
        }
      }

      if (!group) {
        group = {
          events: [],
          date: date
        };
        groups.push(group);
      }
      this._initEventStatus(event);
      group.events.push(event);
    });

    // sort event by time
    groups.forEach((group) => {
      group.events.sort((a: any, b: any) => a.startTime - b.startTime);
    });

    return groups;
  }

  private _initEventStatus(event: any) {
    let now = new Date();
    event.progressing = event.start < now && event.end > now;
    event.ended = event.end < now;
    event.pending = event.start > now;

    if (event.progressing) {
      event.statusText = 'Đang diễn ra';
      event.statusColor = this.colors[0];
    } else if (event.pending) {
      event.statusText = 'Chưa diễn ra';
      event.statusColor = this.colors[5];
    } else {
      event.statusText = 'Kết thúc';
      event.statusColor = this.colors[6];
    }

    event.style = {
      'background-color': this.colors[event.mode]
    };
  }
}
